// Логотипы и фон авторизации выбранного бренда.
//
// Файлы лежат в src/brand/<бренд>/. require с шаблоном заставляет webpack
// положить в сборку оба набора и выбрать нужный по BRAND на старте — так
// сборка не зависит от порядка импортов.
import { BRAND } from './brand';

export const logo = require(`./${BRAND}/logo.svg`);
export const authLogo = require(`./${BRAND}/authLogo.svg`);
export const authBackground = require(`./${BRAND}/background.jpg`);
